require("!!/var/lib/jenkins/workspace/TEST2/webapp/node_modules/script-loader/addScript.js")(require("!!/var/lib/jenkins/workspace/TEST2/webapp/node_modules/raw-loader/index.js!/var/lib/jenkins/workspace/TEST2/webapp/src/main/webapp/js/lib/kendo/kendo.angular.min.js"))


//////////////////
// WEBPACK FOOTER
// ./~/script-loader!./src/main/webapp/js/lib/kendo/kendo.angular.min.js
// module id = 172
// module chunks = 37